import React, { Fragment, useEffect, useMemo } from "react";
import logo from "../../../assets/media/logo.png";
import GamingBoardBahamasLogo from "../../../assets/media/GamingBoardBahamasLogo.png";
import iconMark from "../../../assets/media/icon-mark.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import GBInput from "../../input";
import * as Yup from "yup";
import { signUp } from "../../../store/reducers/signUpSlice";
import { loginUser } from "../../../store/reducers/authSlice";
import { showError } from "../../../helpers/toast";

const parseSignupClaims = (jwt) => {
  if (!jwt || typeof jwt !== "string") return null;
  try {
    const payload = jwt.split(".")[1];
    if (!payload) return null;
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};

const SignUp3 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signUpUser = useSelector((state) => state.signUp);
  const loading = useSelector((state) => state.signUp.loading);
  const user = useSelector((state) => state.auth.user);
  const signupData = useSelector((state) => state?.signUp?.data?.payload);

  const claims = useMemo(
    () => parseSignupClaims(signUpUser.signupcode),
    [signUpUser.signupcode]
  );
  const expectedOtp = claims?.secretPin != null ? String(claims.secretPin) : "";

  const initialValues = {
    otp: "",
  };

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required("OTP is required")
      .test("otp-match", "Enter correct OTP code", (value) =>
        expectedOtp ? String(value) === expectedOtp : false
      ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async () => {
      if (!signUpUser?.signupcode) {
        showError("Signup session expired. Please use your invitation link again.");
        navigate("/signup-step1");
        return;
      }

      try {
        const signupResponse = await dispatch(
          signUp({
            userData: {
              signupcode: signUpUser.signupcode,
              password: signUpUser.password,
              full_name: signUpUser.full_name,
              phone: signUpUser.phone,
              companyRegistrationNo: signUpUser.companyRegistrationNo,
            },
          })
        ).unwrap();

        const userEmail =
          signupResponse?.user?.email ||
          signUpUser?.message?.user?.email ||
          user?.email;

        if (userEmail && signUpUser.password) {
          await dispatch(
            loginUser({
              emailOrPhone: userEmail?.toLowerCase()?.trim(),
              password: signUpUser.password,
            })
          );
        } else {
          navigate("/");
        }
      } catch (error) {
        const errorMessage =
          error?.message || error?.response?.data?.error || "";
        if (
          errorMessage.toLowerCase().includes("invalid signuo code") ||
          errorMessage.toLowerCase().includes("invalid signup code")
        ) {
          showError(
            "The link is expired. Please contact the service provider."
          );
        } else {
          showError(errorMessage || "Failed to complete signup");
        }
      }
    },
  });

  useEffect(() => {
    if (!signUpUser?.signupcode || !signUpUser?.password) {
      navigate("/signup-step1");
    }
  }, [navigate, signUpUser?.signupcode, signUpUser?.password]);

  useEffect(() => {
    if (user?.access_token || signupData?.access_token) {
      navigate("/");
    }
  }, [navigate, user, signupData]);

  const { values, handleChange, handleSubmit, errors } = formik;
  const otpMatches = expectedOtp && values.otp === expectedOtp;

  const fields = [
    {
      name: "otp",
      label: "OTP",
      type: "text",
      placeholder: "Enter OTP",
      value: values.otp,
      onChange: handleChange,
      iconSrc: iconMark,
    },
  ];

  return (
    <div className="App">
      <div className="container">
        <div className="landingWrapper">
          <div className="landingRow">
            <div className="landingCol">
              <div className="fieldsWrapper">
                <img src={logo} className="logo" alt="logo" />
                <h2>Signup With Us</h2>
                <p>We have sent OTP on your given number</p>

                <form className="gb-login-form" onSubmit={handleSubmit}>
                  {fields.map((field, index) => {
                    return (
                      <Fragment key={index}>
                        <GBInput
                          name={field.name}
                          type={field.type}
                          label={field.label}
                          value={field.value}
                          placeholder={field.placeholder}
                          setValue={handleChange}
                        />
                        {errors[`${field.name}`] && (
                          <div className="error-message error-message-wrap">
                            {errors[`${field.name}`]}
                          </div>
                        )}
                      </Fragment>
                    );
                  })}
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                      defaultChecked
                      readOnly
                    />
                    <label className="form-check-label" htmlFor="flexCheckChecked">
                      I agree to <a href="#">Terms of Service</a> &{" "}
                      <a href="#">Privacy Policy</a>
                    </label>
                  </div>
                  <div className="gb-form-footer">
                    <button
                      type="submit"
                      style={{
                        background: !otpMatches ? "#ccc" : undefined,
                        border: !otpMatches ? "solid 1px #ccc" : undefined,
                      }}
                      disabled={!otpMatches || loading}
                      className="form-submit"
                    >
                      {loading ? (
                        <>
                          <div
                            className="text-xs spinner-border text-light"
                            style={{ width: "1rem", height: "1rem" }}
                            role="status"
                          ></div>
                          <span className="sr-only ml-5"> Loading...</span>
                        </>
                      ) : (
                        "Sign Up"
                      )}
                    </button>
                  </div>
                </form>
                <div className="gb-step-list">
                  <span className="current"></span>
                  <span className="current"></span>
                  <span className="current"></span>
                </div>
              </div>
            </div>
            <div className="landingCol">
              <div className="imageWrapper">
                <div className="loginBox">
                  <p>
                    Already have account? <Link to={"/"}>Sign In</Link>
                  </p>
                </div>
                <img
                  width={"300px"}
                  height={"300px"}
                  src={GamingBoardBahamasLogo}
                  className="booksAnimation"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp3;
